import React from 'react';
import styles from './HeaderFilterSelection.module.scss';
import Tag from './Tag';

function HeaderFilterSelection(props) {
    const { className = '', tags = [], onClick, onTagClick, onClearButtonClick } = props;

    if (!tags.length) return null;

    return (
        <div className={[styles.HeaderFilterSelection, className].join(' ')}>
            <div className={[styles.tagContainer, onClick ? styles.clickable : ''].join(' ')} onClick={onClick}>
                {tags.map((tag, i) => (
                    <Tag className={styles.tag} tag={tag} key={i} onClick={onTagClick} />
                ))}
            </div>
            {onClearButtonClick ? <button type="button" className={styles.clearAll} onClick={onClearButtonClick}></button> : null}
        </div>
    );
}

export default HeaderFilterSelection;
